import { Button, Card, Checkbox, Input, List, ListItem, ListItemPrefix, Option, Radio, Select, Textarea, Typography } from "@material-tailwind/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Breadcrumb } from "../Breadcrumb";
import NotFound from "./NotFound";
import "../../styles/payment.css";
import { PlusCircleIcon, PlusIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { AddUserInfo, GetUserInfoById } from "../../services/ApiServices/UserService";
import parseJwt from "../../services/parseJwt";
import { GetAllDistrictsByProvince, GetAllProvinces, GetAllWardsByDistrict, GetDistrictByCode, GetDistrictByName, GetProvinceByCode, GetProvinceByName, GetWardByCode, GetWardByName } from "../../services/ApiServices/AddressService";
import { log } from "console";
import App from "../..";
import { PaymentProductRow } from "../PaymentProductRow";
import { formatPrice } from "../../services/formatPrice";
import { CreateOrder } from "../../services/ApiServices/OrderService";
import moment from "moment";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { NotifyCustomerOrder, notifyOrder } from "../../services/ApiServices/AuthenticationService";

type PaymentProps = {
  token: string | null
  fetchCartProducts: () => void
  setSelectedProducts: (products: any) => void
  selectedProducts: any[]
  selectedProductsPrice: number
  setSelectedProductsPrice: (price: number) => void
  deleteCartProduct: (id: string) => Promise<void>
}

type UserInfo = {
  id: number
  email: string
  receiverName: string
  address: string
  addressInfo: string
  phoneNumber: string
  additionalInfo: string

}

function Payment({ token, selectedProductsPrice, deleteCartProduct, setSelectedProductsPrice, fetchCartProducts, selectedProducts, setSelectedProducts }: PaymentProps) {

  const location = useLocation();
  const navigate = useNavigate();

  const [addAddress, setAddAddress] = useState(false);
  const [saveAddress, setSaveAddress] = useState(false);

  const [deliveryFee, setDeliveryFee] = useState(0);

  const [provinces, setProvinces] = useState([] as any[]);
  const [districts, setDistricts] = useState([] as any[]);
  const [wards, setWards] = useState([] as any[]);

  const [province, setProvince] = useState({} as any);
  const [district, setDistrict] = useState({} as any);
  const [ward, setWard] = useState({} as any);

  const [userInfo, setUserInfo] = useState({} as UserInfo);
  const [errorMessage, setErrorMessage] = useState("");
  const [paymentErrorMessage, setPaymentErrorMessage] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isTermsDialogOpen, setIsTermsDialogOpen] = useState(false);


  const openAddressForm = () => setAddAddress(!addAddress);
  const uid = token ? parseJwt(token).id : null

  const handleButtonClick = () => {
    setIsDialogOpen(true);
  };

  const handleYes = async () => {
    const result = await saveUserInfo();
    setSelectedProducts([]);
    setIsDialogOpen(false);
  };


  const handleNo = () => {
    setIsDialogOpen(false);
  };

  const handleOpenTerms = () => {
    setIsTermsDialogOpen(true);
  };

  const [imageFile, setImageFile] = useState("");
  const handleImageChange = (event: any) => {
    setImageFile(event.target.files[0]);
  };

  const handleCloseTerms = () => {
    setIsTermsDialogOpen(false);
  };

  const fetchUserInfos = async () => {
    let userInfos = null;
    try {
      userInfos = await GetUserInfoById(uid);
      let addressInfos = userInfos.addressInfo.split(", ");
      let p = await GetProvinceByName(addressInfos[0]);
      let d = await GetDistrictByName(addressInfos[1]);
      let w = await GetWardByName(addressInfos[2]);

      setDeliveryFee(calculateExpectedShippingFee(p.name_with_type));

      setProvince(p);
      setDistrict(d);
      setWard(w);

      setUserInfo(userInfos);
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An error occurred. Please try again later.');
      }
      return;
    }
  }

  const saveUserInfo = async () => {
    let userInfos: any = null;
    var paymentMethods: any = document.getElementsByName('vertical-list');
    var pay = null;
    for (var i = 0; i < paymentMethods.length; i++) {
      if (paymentMethods[i].checked) {
        pay = paymentMethods[i].value;
      }
    }
    if (pay == null) {
      setPaymentErrorMessage("Please select a payment method");
      return false;
    }
    console.log(pay);
    setPaymentErrorMessage("");
    try {
      userInfos = {
        receiverName: userInfo.receiverName,
        email: userInfo.email,
        address: userInfo.address,
        phoneNumber: userInfo.phoneNumber,
        addressInfo: `${province.name_with_type}, ${district.name_with_type}, ${ward.name_with_type}`,
        additionalInfo: userInfo.additionalInfo,
        isSaved: saveAddress,
        userId: uid
      }
      const info = await AddUserInfo(userInfos);
      let cp: any = [];
      selectedProducts.forEach((product: any) => {
        cp.push({
          productSizeId: product.productSizeId,
          quantity: product.quantity
        });
        deleteCartProduct(product.id);
      });
      console.log(cp)

      const now = new Date();
      const orderDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}.000Z`;
      if (imageFile || pay == "Cash") {
        const formData = new FormData();
        formData.append("description", "order");
        formData.append("orderDate", orderDate);
        formData.append("userInfoId", info.id);
        formData.append("expectedOrderDate", calculateExpectedShippingDate(province.name_with_type));
        formData.append("image", imageFile);
        formData.append("paymentMethod", pay);
        formData.append("deliveryFee", deliveryFee + "");
        formData.append("cartProducts", JSON.stringify(cp));
        try {
          const result = await CreateOrder(formData);
          const notifyResult = await notifyOrder(result.id);
          if (notifyResult.success) {
            console.log("Notification email sent successfully.");
          } else {
            console.error("Failed to send notification email:", notifyResult.error);
          }
          const customerNotifyResult = await NotifyCustomerOrder(result.id, userInfo.email);
          if (customerNotifyResult.success) {
            console.log("Customer notification email sent successfully.");
          } else {
            console.error("Failed to send customer notification email:", customerNotifyResult.error);
          }
          setSelectedProducts([]);
          setSelectedProductsPrice(0);
          fetchCartProducts();
          navigate("/payment-success")
          setUserInfo(userInfos);
        } catch (error) {
          console.error("Image upload failed:", error);
        }
      }
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An error occurred. Please try again later.');
      }
      return;
    }
  }

  const calculateExpectedShippingDate = (address: string) => {
    if (address.includes("Thành phố Hồ Chí Minh")) {
      return moment().add(3, 'days').format('YYYY-MM-DDT00:00:00');
    } else {
      return moment().add(7, 'days').format('YYYY-MM-DDT00:00:00');
    }
  };

  const calculateExpectedShippingFee = (address: string) => {
    if (address.includes("Thành phố Hồ Chí Minh")) {
      return 0;
    } else {
      return 30000;
    }
  };

  const fetchProvinces = async () => {
    let provinces = null;
    try {
      provinces = await GetAllProvinces();
      setProvinces(provinces);
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An error occurred. Please try again later.');
      }
      return;
    }
  }

  const fetchDistricts = async (e: any) => {
    let userInfos = null;
    try {
      userInfos = await GetAllDistrictsByProvince(e);
      setDistricts(userInfos);
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An error occurred. Please try again later.');
      }
      return;
    }
  }

  const fetchWards = async (e: any) => {
    let userInfos = null;
    try {
      userInfos = await GetAllWardsByDistrict(e);
      setWards(userInfos);
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An error occurred. Please try again later.');
      }
      return;
    }
  }

  useEffect(() => {
    fetchUserInfos();
  }, [])

  useEffect(() => {
    fetchProvinces();
    if (province) {
      fetchDistricts(province.code);
      if (district) {
        fetchWards(district.code);
      }
    }
  }, [userInfo])

  if (!uid || selectedProducts.length === 0) {
    return (
      <NotFound />
    )
  }

  return (
    <>
      <div className="flex flex-wrap px-5 w-full my-5" style={{ gap: "8%" }}>
        <div className="w-full lg:w-8/12">
          <div className="mb-5">
            <Breadcrumb text1="Giỏ hàng" link1="products" text2="Thanh toán" link2="payment" />
          </div>
          <hr className="bg-gray-500 mb-3" style={{ width: "100%", height: "2px" }} />
          <div className="address-form-wrapper mb-3">
            <p>Địa chỉ giao hàng</p>
            <br></br>
            <div className={`address-form`}>
              <Input label="Họ và tên" crossOrigin={""} value={userInfo?.receiverName}
                onChange={(e) => setUserInfo({ ...userInfo, receiverName: e.target.value })} />
              <Input label="Địa chỉ" crossOrigin={""} value={userInfo?.address}
                onChange={(e) => setUserInfo({ ...userInfo, address: e.target.value })} />
              <div className="flex flex-wrap gap-3 ">
                <div className="w-full lg:w-4/12">
                  <div className="relative h-10 min-w-[200px]">
                    <select className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-gray-900 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                      onChange={async (e) => {
                        fetchDistricts(e.currentTarget.value);
                        const selectedProvince = await GetProvinceByCode(e.currentTarget.value);
                        setDeliveryFee(calculateExpectedShippingFee(selectedProvince.name_with_type));
                        setProvince(selectedProvince);
                      }}
                      value={province.code}>
                      {provinces.map((province: any) => (
                        <option value={`${province.code}`}>{province.name_with_type}</option>
                      ))}

                    </select>
                    <label
                      className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-gray-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-gray-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-gray-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                      Tỉnh/Thành
                    </label>
                  </div>
                </div>
                <div className="w-full lg:w-4/12">
                  <div className="relative h-10 min-w-[200px]">
                    <select className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-gray-900 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                      onChange={async (e) => {
                        fetchWards(e.currentTarget.value);
                        const selectedDistrict = await GetDistrictByCode(e.currentTarget.value);
                        setDistrict(selectedDistrict);
                      }}
                      value={district.code}>
                      {districts.map((district: any) => (
                        <option value={`${district.code}`}>{district.name_with_type}</option>
                      ))}
                    </select>
                    <label
                      className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-gray-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-gray-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-gray-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                      Quận/Huyện
                    </label>
                  </div>
                </div>
                <div className="w-full lg:w-3/12 grow">
                  <div className="relative h-10 min-w-[200px]">
                    <select className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-gray-900 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                      onChange={async (e) => {
                        const selectedWard = await GetWardByCode(e.currentTarget.value);
                        setWard(selectedWard);
                      }}
                      value={ward.code}>
                      {wards.map((ward: any) => (
                        <option value={`${ward.code}`}>{ward.name_with_type}</option>
                      ))}
                    </select>
                    <label
                      className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-gray-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-gray-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-gray-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                      Phường/Xã
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-3 justify-between">
                <div className="w-full lg:w-6/12 grow">
                  <Input className="w-full" label="Email" crossOrigin={""} value={userInfo?.email}
                    onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })} />
                </div>
                <div className="w-full lg:w-5/12">
                  <Input className="w-full" label="Số Điện Thoại" crossOrigin={""} value={userInfo?.phoneNumber}
                    onChange={(e) => setUserInfo({ ...userInfo, phoneNumber: e.target.value })} />
                </div>
              </div>
              <Textarea label="Ghi chú" value={userInfo?.additionalInfo}
                onChange={(e) => setUserInfo({ ...userInfo, additionalInfo: e.target.value })} />
            </div>

          </div>
          <div className="method-form mb-3">
            <p className="mb-3">Phương thức thanh toán</p>
            <hr className="bg-gray-500 mb-3" style={{ width: "100%", height: "2px" }} />

            <div className={`${paymentErrorMessage ? "bg-red-50 p-3" : ""} rounded`}>
              <Card className="border border-black" placeholder={""}>
                <List placeholder={""}>
                  <ListItem className="p-0" placeholder={""}>
                    <label
                      htmlFor="vertical-list-cod"
                      className="flex w-full cursor-pointer items-center px-3 py-2"
                    >
                      <ListItemPrefix className="mr-3" placeholder={""}>
                        <Radio
                          name="vertical-list"
                          id="vertical-list-cod"
                          color="blue"
                          value={"Cash"}
                          ripple={false}
                          className="hover:before:opacity-0"
                          containerProps={{
                            className: "p-0",
                          }}
                          crossOrigin={""}
                          onChange={() => {
                            const bankImageElement = document.getElementById("bankimage");
                            if (bankImageElement) {
                              bankImageElement.style.display = "none";
                            }
                            const ImageElement = document.getElementById("imageinput");
                            if (ImageElement) {
                              ImageElement.style.display = "none";
                            }
                          }}
                        />
                      </ListItemPrefix>
                      <img src="/COD.png" className="h-12 w-12" />
                      <Typography
                        style={{ marginLeft: "5px" }}
                        color="gray"
                        className="font-medium text-blue-gray-400 grow"
                        placeholder={""}
                      >
                        Thanh toán khi nhận hàng (COD)
                      </Typography>
                      <Typography
                        color="black"
                        className="font-bold text-black"
                        placeholder={""}
                      >
                        {""}
                      </Typography>
                    </label>
                  </ListItem>
                  <ListItem className="p-0" placeholder={""}>
                    <label
                      htmlFor="vertical-list-momo"
                      className="flex w-full cursor-pointer items-center px-3 py-2"
                    >
                      <ListItemPrefix className="mr-3" placeholder={""}>
                        <Radio
                          name="vertical-list"
                          id="vertical-list-momo"
                          color="blue"
                          value={"Thanh toán qua chuyển khoản"}
                          ripple={false}
                          className="hover:before:opacity-0"
                          containerProps={{
                            className: "p-0",
                          }}
                          crossOrigin={""}
                          onChange={() => {
                            const bankImageElement = document.getElementById("bankimage");
                            if (bankImageElement) {
                              bankImageElement.style.display = "block";
                            }
                            const ImageElement = document.getElementById("imageinput");
                            if (ImageElement) {
                              ImageElement.style.display = "block";
                            }
                          }} />
                      </ListItemPrefix>
                      <img src="/nganhang.jpg" className="h-12 w-12" />
                      <Typography
                        style={{ marginLeft: "5px" }}
                        color="gray"
                        className="font-medium text-blue-gray-400 grow"
                        placeholder={""}
                      >
                        Thanh toán qua chuyển khoản (Lời nhắn: "Tên của bạn" thanh toán )

                      </Typography>
                      <br></br>

                      <Typography
                        color="black"
                        className="font-bold text-black"
                        placeholder={""}
                      >
                        {""}
                      </Typography>
                    </label>
                  </ListItem>
                  <input
                    id={"imageinput"}
                    type="file"
                    onChange={handleImageChange}

                    style={{ marginTop: 7, marginLeft: 44, display: "none" }}
                  />
                </List>
              </Card>
              <div className="text-red-500">{paymentErrorMessage}</div>
            </div>
          </div>
        </div>
        <div className="order-summary w-full lg:w-3/12 mb-3">
          <div className="">
            {selectedProducts.length > 0 && selectedProducts.map((product: any) => (
              <PaymentProductRow product={product} key={product.id} />
            ))}
          </div>
          <h2 className="text-2xl font-medium mb-3">Tổng hóa đơn</h2>
          <hr className="bg-gray-500 mb-3" style={{ width: "100%", height: "2px" }} />
          <div className="order-info flex">
            <p className="font-medium grow">Tổng tiền</p>
            <p className="font-medium text-black">{formatPrice(selectedProductsPrice)}</p>
          </div>
          <p className="font-medium grow">Giảm giá</p>
          <div className="flex gap-2 mb-3">
            <div className="w-2/3">
              <Input label="Mã giảm giá" disabled crossOrigin={""} />
            </div>
            <div className="w-1/3">
              <Button color="deep-orange" className="text-white w-full" disabled placeholder={""}>
                Sử dụng
              </Button>
            </div>
          </div>
          <div className="flex">
            <p className="font-medium grow">Phí vận chuyển</p>
            <p className="text-black font-medium">{formatPrice(deliveryFee)}</p>
          </div>
          <hr className="bg-gray-500 mb-3" style={{ width: "100%", height: "2px" }} />
          <div className="flex text-xl">
            <p className="font-medium grow">Tổng cộng: </p>
            <p className="text-black font-medium">{formatPrice(selectedProductsPrice + deliveryFee)}</p>
          </div>
          <br></br>
          <img id="bankimage" style={{ marginLeft: "80px", height: "250px", display: "none" }} src="bank.jpeg" alt="" />
        </div>
      </div>
      <div className="mb-8 ml-3">
        <div>
          <Checkbox color="deep-orange" className="block" label="Lưu thông tin giao hàng"
            onChange={(e) => setSaveAddress(e.target.checked)}
            crossOrigin={""} />
        </div>
        <div className="ml-4 mb-8">
          <Button color="deep-orange" className="text-white" placeholder={""}
            onClick={handleButtonClick}>
            Hoàn tất đơn
          </Button>

          <Dialog
            open={isDialogOpen}
            onClose={handleNo}
          >
            <DialogTitle>Xác nhân đặt hàng</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Khi bấm "Đồng ý" nghĩa là bạn phải tuân thủ
                <span className="ml-1 underline" color="brown" onClick={handleOpenTerms} style={{ padding: 0, minHeight: 0, minWidth: 0 }}>
                  Điều khoản đặt hàng.
                </span>
                <p />Bạn đồng ý chứ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button placeholder={""} onClick={handleYes} color="deep-orange" autoFocus>
                Tôi đồng ý
              </Button>
              <Button placeholder={""} onClick={handleNo} color="light-blue">
                Huỷ
              </Button>

            </DialogActions>
          </Dialog>
          <Dialog
            open={isTermsDialogOpen}
            onClose={handleCloseTerms}
          >
            <DialogTitle>Điều khoản đặt hàng</DialogTitle>
            <DialogContent>
              <DialogContentText>
                1. CHẤP THUẬN<br />
                Đơn không ràng buộc cho đến khi Bên Cung Cấp chấp thuận bằng văn bản trong vòng 30 ngày. Bên Mua có thể rút lại Đơn trước khi được chấp thuận.<br /><br />
                2. NGÀY GIAO HÀNG<br />
                Bên Cung Cấp phải giao Hàng Hóa đúng hạn và thông báo nếu có trì hoãn. Bên Mua có thể chấm dứt Đơn nếu Hàng Hóa không giao đúng hạn và yêu cầu bồi thường. Hàng Hóa giao trước có thể bị trả lại.<br /><br />
                3. SỐ LƯỢNG<br />
                Bên Mua có quyền từ chối nếu số lượng không đúng như đặt hàng. Nếu chấp nhận, Mức Giá sẽ được điều chỉnh theo tỷ lệ.<br /><br />
                4. QUYỀN SỞ HỮU VÀ RỦI RO MẤT MÁT<br />
                Quyền sở hữu chuyển qua Bên Mua khi giao Hàng Hóa đến Nơi Giao Hàng. Bên Cung Cấp chịu rủi ro đến khi giao.<br /><br />
                5. ĐÓNG GÓI<br />
                Hàng hóa phải được đóng gói đảm bảo không tổn hại.<br /><br />
                6. BẢO HÀNH<br />
                Bên Cung Cấp bảo đảm Hàng Hóa trong 18 tháng không lỗi, phù hợp thông số, và không vi phạm quyền sở hữu trí tuệ. Bên Cung Cấp phải thay thế hoặc sửa chữa Hàng Hóa lỗi trong 30 ngày.<br /><br />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button placeholder={""} onClick={handleCloseTerms} color="light-green">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </>
  )
}

export default Payment;
